<template lang="pug">
div
  main.promo
    TwitchSelect
    Faq
    Download

  MainFooter
  ProjectRegistrationForm
  UserTransfer
</template>

<script>
import ProjectRegistrationForm from "@godweb/frontend-base/src/components/register/mygames/ProjectReg.vue";
import UserTransfer from "@static_promo_pages/common/components/user_transfer/vue/UserTransfer";
import UserMixin from "@godweb/frontend-base/src/mixins/user/UserMixin";
import MainFooter from "@static_promo_pages/common/components/footer/vue/Footer.vue";
import TwitchSelect from "./blocks/TwitchSelect";
import Faq from "./blocks/Faq";
import Download from "./blocks/Download";

export default {
  name: "Index",

  components: {
    MainFooter,
    ProjectRegistrationForm,
    TwitchSelect,
    Faq,
    Download,
    UserTransfer,
  },

  mixins: [UserMixin],

  data() {
    return {
      promo_name: "twitchregionselect",
    };
  },

  created() {
    document.addEventListener("init_vue_components", () => {
      this.initPromo();
    });
  },

  methods: {
    async initPromo() {
      await this.$store.dispatch("global/auth");
    },
  },
};
</script>
